'use strict';
export var portalControllersModule =  angular.module('portal.controllers', ['portal.services','dev-stack-frontend.controllers']);